import { useTranslation } from 'react-i18next';

import { LogoutIcon } from '@shared/assets/icons';
import { i18TranslationNS, Translation } from '@shared/config/i18n';
import { TabButton } from '@shared/ui/tabButton';

import { useLogOut } from '../model';

export const LogOutButton = () => {
	const { t: tT } = useTranslation(i18TranslationNS);
	const { handleLogOut, isLoading } = useLogOut();

	const label = tT(Translation.LOGOUT_SIGN_OUT);

	return (
		<TabButton
			leftIcon={LogoutIcon}
			label={label}
			className='nav-item nav-item--dropdown'
			labelClassName='body-medium-base nav-item__title'
			iconClassName='nav-item__icon'
			onClick={handleLogOut}
			role='menuitem'
			disabled={isLoading}
		/>
	);
};
